"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  shell: {
    componentTitle: 'Erfüllungskonfigurationen',
    incompletePropsMessage: 'Niet genoeg informatie verstrekt, vul alle verplichte velden voor testbestellingen in.'
  },
  selectedConfigurationDisplay: {
    selectedConfigurationLabel: 'AUSGEWÄHLTE KONFIGURATION:',
    noSelectedConfigurationLabel: 'Wählen Sie eine Konfiguration:',
    clearButton: 'Klare Auswahl'
  },
  fulfillmentConfigurationList: {
    actions: {
      error500: 'Beim Abrufen der Liste der Erfüllungskonfigurationen ist ein Fehler aufgetreten.' + ' Sie können erneut versuchen, um zu sehen, ob es behoben wird.',
      permissionsError: 'Sie haben anscheinend keine Berechtigung zum Anzeigen dieser Erfüllungskonfigurationen.' + ' Bitte wenden Sie sich an den Plattform-Support, um Zugriff zu erhalten.',
      unknownError: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut.'
    },
    table: {
      nameHeader: 'Name der Erfüllungskonfiguration'
    },
    selectVersionButton: 'Version auswählen'
  },
  fulfillmentConfigurationErrorPage: {
    noAvailableFulfillmentConfigurations: {
      titleText: 'Für dieses Produkt sind keine Erfüllungskonfigurationen verfügbar.',
      productAssociationsSuggestion: 'Überprüfe dein ',
      productAssociationsLink: 'Produktzuordnungen',
      fulfillmentConfigurationsSuggestion: 'Erstelle eine neue ',
      fulfillmentConfigurationsLink: 'Erfüllungskonfiguration',
      emailSuggestion: 'Benötigen Sie weitere Unterstützung? Kontakt ',
      emailLink: 'platformsupport@cimpress.com',
      tryAgainText: 'Einige Änderungen vorgenommen? Klicken Sie hier, um es erneut zu versuchen.'
    },
    error: {
      errorTitle: 'Beim Laden der Fulfillment-Konfigurationen ist ein Fehler aufgetreten'
    },
    reloadButtonText: 'Neu laden'
  },
  search: {
    searchFieldLabel: 'Suchkonfigurationen'
  },
  versionsList: {
    table: {
      moreInfoButton: 'Mehr Info',
      rowContentsHeader: 'Ausführung',
      noVersionsText: 'Keine Versionen gefunden'
    },
    backButton: 'Zurück'
  }
};
exports["default"] = _default;